import store from "@/store";
import { addStandardFields, apiUrl } from "./fetchData";
const setLastRequest = ({ url, result, status }) =>
  store.dispatch("setLastRequest", { url, result, status });

// Resolves to { reader, status, message, body }. The reader is only set for successful
// responses; otherwise body is the JSON the API sent, if any.
const fetchStream = async (
  endpoint,
  body,
  addPrompt = true,
  addJourneyId = true,
  addUserId = true,
  signal = undefined
) => {
  await addStandardFields(body, addPrompt, addJourneyId, addUserId);
  const url = apiUrl(endpoint);
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
    signal,
  });
  setLastRequest({ url, result: null, status: response.status });

  if (!response.ok || !response.body) {
    let body = {};
    try {
      body = (await response.json()) || {};
    } catch {
      // No JSON body
    }
    return {
      reader: null,
      status: response.status,
      message: body.message || "",
      body,
    };
  }

  const reader = response.body
    // eslint-disable-next-line no-undef
    .pipeThrough(new TextDecoderStream())
    .getReader();
  return { reader, status: response.status, message: "" };
};

export default fetchStream;
